(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory(
            'action-notify', actionFunc);

    function actionFunc(lodash, CommonHelper, notifier) {
        return function(options, eventData, actionResponse) {
            const appliedOptions = angular.copy(options);
            if (lodash.get(options, 'remote_message', true)) {
                var msg_field_name = lodash.get(options, 'msg_field_name', 'display_msg');
                const remote_message = lodash.get(actionResponse, msg_field_name, '');
                if (!CommonHelper.isEmpty(remote_message)) {
                    appliedOptions.template = remote_message;
                }
            }

            notifier.notify(
                angular.merge(
                    {},
                    {
                        template: '&nbsp;',
                        hasDelay: true,
                        delay: 3000,
                        type: '', // default success warning info error
                        position: 'top center',
                        // classes: 'test'
                    },
                    appliedOptions
                ));
        };
    }
})();